import React,{useCallback,useRef} from 'react'
import ReactDOM,{unmountComponentAtNode} from 'react-dom';
import styled,{keyframes} from 'styled-components';
import { BsCheck, BsExclamation, BsArrowUpShort } from 'react-icons/bs';
import { IoIosClose } from 'react-icons/io'
import {IoClose} from 'react-icons/io5'
import {VscClose} from 'react-icons/vsc'
import { thisExpression } from '@babel/types';
import {FiPaperclip} from 'react-icons/fi'
import Tooltip from "@material-ui/core/Tooltip";

const Notification = styled.div`
    display:flex;
    cursor: pointer;
    position:relative;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    padding-left: 10px;
    z-index: 1300;
    width: auto;
    height:56px;
    padding-bottom: 1px;
    padding-right:5px;
    background: white;
    border-radius: 3px;
    box-shadow: 0px 0px 10px rgba(0,0,0,.2);
`
const Container = styled.div`
    display:flex;
    position:absolute;
    justify-content: center;
    align-items:center;
    z-index: 1300;
    width: 350px;
    height:56px;
    top:30px;
    opacity:1;
    left: 0px;
    right: 0px;
    margin-left: auto;
    margin-right: auto;
`

const anime = keyframes`
    from{
        top:0px;
        opacity:0;
    }
    to{
        top:30px;
        opacity:1;
    }
`

const ContainerAnime = styled(Container)`
    animation: ${anime} 0.2s ease-in-out;
`

const Message = styled.div`
    display: flex;
    width: auto;
    height: 80%;
    padding-top: 5px;
    margin-left: 10px;
    line-height: 20px;
    justify-content: center;
    flex-direction: column;
`
const Icon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    min-width: 25px;
    min-height: 25px;
    border-radius: 12px;
    background: #2db94d;
`
const TextEllipsis = styled.div`
  -webkit-touch-callout: none; 
    -webkit-user-select: none; 
     -khtml-user-select: none;
       -moz-user-select: none; 
        -ms-user-select: none; 
            user-select: none;
  width: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 550px;
`

const Close = styled.div`
    display:flex;
    margin-left: 11px;
    width:18px;
    height:18px;
    justify-content: center;
    align-items: center;
    border-radius:9px;
    background:rgba(150,150,150,0);
    &:hover{
        background:rgba(150,150,150,.1);
    }
`
const rotate = keyframes`
  from {
    transform: scale(0.99);
    
  }
  to {
    transform: scale(0.1);
  }
`

const LineTemp = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    overflow:hidden;
    height: 80%;
    width: 4px;
    background:#c1f0cc;
    border-radius: 2em;
    transform: scale(0.99);
`

const Line = styled.div`
    display: flex;
    height: 50px;
    min-width: 30px;
    background: #2db94d;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
`

const AnimeLoad = styled(Line)`
    animation: ${rotate} 2.5s linear;
`
function getLine(color,colorSec){
    return {
    line:styled(Line)
        `
        background: ${color};
        &::before{
            background: ${colorSec}
        }
        `,
    anime:styled(AnimeLoad)
        `
        background: ${color};
        &::before{
            background: ${colorSec}
        }
        `}
}
const OutLine={
    check: styled(LineTemp)
    `background:rgba(255, 116, 24,.35);`,
    error: styled(LineTemp)
    `background:rgba(94, 37, 114,.35);`,
    exclamation: styled(LineTemp)
    `background:#b4cde6;`,
}
const LineNotify= 
{
    check: getLine('#FF7418','rgba(255, 116, 24,.35)'),
    error: getLine('#5E2572','rgba(94, 37, 114,.35)'),
    exclamation: getLine('#2971B8','#b4cde6'),
}
const BoxNotify= 
{
    check:styled(Icon)`background: #FF7418;`,
    error: styled(Icon)`background: #5E2572;`,
    exclamation:styled(Icon)`background: #2971B8;`
}
const IconNotify =
{
    check:{icon:BsCheck,style:{fontSize:'1.2rem'}},
    error:{icon:IoClose,style:{fontSize:'15px'}},
    exclamation:{icon:BsExclamation,style:{fontSize:'1.3rem'}}
}

const Arrow = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    margin-left:3px;
    width: 16px;
    height: 16px;
    border-radius:8px;
    &:hover{
        background: ${props=>props.hover?'rgba(150,150,150,.1)':'none'};
    }
`

const Copy = styled.div`
    display:flex;
    position:absolute;
    flex-direction:row;
    z-index:1300;
    bottom:-40px;
    width:100px;
    padding:0px 10px 0px 17px;
    justify-content:center;
    align-items:center;
    height:30px;
    left:0px;
    right:0px;
    margin-left:auto;
    margin-right:auto;
    background:white;
    color:#404040;
    border-radius: 3px;
    box-shadow: 0px 0px 10px rgba(0,0,0,.2);
    &:before{
        content:'';
        position:absolute;
        left: 0px;
        width:8px;
        height:100%;
        background:var(--gray);
        border-bottom-left-radius: 3px;
        border-top-left-radius:3px;
    }
`

const move = keyframes`
  from {
    bottom:0px;
    
  }
  to {
    bottom:-40px;
  }
`

const CopyAnime = styled(Copy)`
    animation:  ${move} 0.1s ease-in-out;
`

function ClipBoard(){
    return (
        <CopyAnime>
            <div>Copiado !</div>
        </CopyAnime>
    )
}

function CreateClipBoard(ref){
    const node = ref
    const rootEl = document.createElement('div')
    rootEl.id = 'clipboard'
    node.insertBefore(rootEl, node.firstChild);
    ReactDOM.render(
      <ClipBoard />,
      rootEl
    )
    setTimeout(() => {
        rootEl.remove()
    }, 1000);
    return rootEl
}

class Notify extends React.Component {

    constructor(props){
        super(props)
        this.class = props.tipo?props.tipo:'check'
        this.state = {load:LineNotify[this.class].anime,lineout:OutLine[this.class],hover:false}
        this.timerS = this.timer()
        this.box = BoxNotify[this.class]
        this.icon = IconNotify[this.class]
        this.refCotainer = React.createRef();
        this.clip = React.createRef();
        this.message = props.message
    }

    remove=()=>{
        if(document.getElementById('notify'))
            document.getElementById('notify').remove()
    }

    copy=()=>{
        copyTextToClipboard(this.message)
        if(this.clip.current) this.clip.current.remove()
        this.clip.current = CreateClipBoard(this.refCotainer.current)
    }

    timer=()=>setTimeout(()=>{
        this.remove()
    },2500)

    stop=()=>{
        clearTimeout(this.timerS)
        this.setState({load:LineNotify[this.class].line,hover:true})
    }
    start=()=>{
        this.timerS = this.timer()
        this.setState({load:LineNotify[this.class].anime,hover:false})
    }

    render () {
      return (
          <>
          <ContainerAnime ref={this.refCotainer} id="reset-notify">

            <Notification onMouseEnter={this.stop} onMouseLeave={this.start}>
                <this.state.lineout> 
                    <this.state.load/>
                </this.state.lineout>
               
                <this.box>
                    <this.icon.icon color={'white'} style={this.icon.style}/>
                </this.box>
                <Message>
                    <div className="d-flex flex-row aligh-items-center">
                        <Tooltip title={this.message}><TextEllipsis style={{fontWeight:'bold'}}>{this.message}</TextEllipsis></Tooltip>
                        <Arrow onClick={this.copy} hover={this.state.hover}>
                            {/* <div style={{display:this.state.hover?'flex':'none',zIndex:'99',transform:'rotateZ(0deg)',fontSize:'12px', color:'#808080'}}>c</div> */}
                            <FiPaperclip style={{display:this.state.hover?'flex':'none',zIndex:'99',transform:'rotateZ(0deg)',fontSize:'0.6rem', color:'#808080'}}/>
                        </Arrow>
                    </div>
                    {/* <TextEllipsis style={{color:'#8c8c8c'}} >Usuário(s) cadastrados com sucesso</TextEllipsis> */}
                </Message>
                <Close onClick={()=>{this.remove()}}>
                    <IoIosClose color={'#8c8c8c'} style={{fontSize:'1.2rem'}}/>
                </Close>
            </Notification>
            </ContainerAnime>
          </>
      )
        
    }
  }

export default function notify(message,tipo){
    let exist = document.getElementById('notify')
    if(exist){
        try{
            Object.values(document.getElementById('reset-notify'))[1].children._self.stop()
        }catch{}
        exist.remove()
    }
    const rootEl = document.createElement('div')
    rootEl.id = 'notify'

    document.body.appendChild(rootEl);
    const msg = Array.isArray(message)?message.join(', '):message
    const type = (tipo==1)?'exclamation':(tipo==2)?'check':'error'
    ReactDOM.render(
      <Notify message={msg} tipo={type}/>,
      rootEl
    )

}

function copyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = 0;
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }
  